module.exports = __webpack_public_path__ + "static/media/logo-color@2x.29627084.png";